import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import {ReactComponent as CardIcon} from '../../assets/new-icons/card.svg';
import {ReactComponent as EuroIcon} from '../../assets/new-icons/euroIcon.svg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import md5 from 'md5';

function PaymentBox() {
    const navigate = useNavigate()
    const token = useSelector((user) => user.user.datiPagamento.token)
    const iban = useSelector((user) => user.user.datiPagamento.account_iban)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const customerIdGas = useSelector((user) => user?.gas?.info?.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const [defaultMethod, setDefaultMethod] = useState()
    const [cards, setCards] = useState()
    const section = useSelector((user) => user.settings.section)
    useEffect(() => {
        getMethod()
    }, [])

    const getMethod = async () => {
        const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${section ? customerIdGas : customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(apiMethod)
        setDefaultMethod(data.dati.metodo_predefinito)
        setCards(data.dati.dati_token)
    }

    return (
        <>
            {defaultMethod === 'RID' ? (
                <div className="paymentBox">
                    <p className='label'>Metodo di pagamento</p>
                    <div className="payName"><CardIcon /><p>Iban bancario</p></div>
                    <p className='cardNumber'>{'IT*****'.concat(iban.slice(iban.length - 4))} </p>
                    <div className="changeMethod" onClick={() => navigate('/enrica/cambio-metodo')}>
                        <EuroIcon className='euroIcon'/>
                        <p>Cambia metodo</p>
                        <ArrowForwardIosIcon className='arrow'/>
                    </div>
                </div>
            ) : cards && cards.map((card, i) => card.token_default === '1' ? (
                <div className="paymentBox" key={i}>
                    <p className='label'>Metodo di pagamento</p>
                    <div className="payName"><CardIcon /><p>Carta di credito</p></div>
                    <p className='cardNumber'>**** **** **** {card.token.slice(card.token.length - 4)}</p>
                    <div className="changeMethod" onClick={() => navigate('/enrica/cambio-metodo')}>
                        <EuroIcon className='euroIcon'/>
                        <p>Cambia metodo</p>
                        <ArrowForwardIosIcon className='arrow'/>
                    </div>
                </div>
            ) : null)}
            {
                defaultMethod === 'Carta di credito' && token === null ? (
                    <div className="paymentBox" style={{height: '120px'}}>
                        <p className="label">Aggiungi un metodo di pagamento</p>
                        <div className="changeMethod" onClick={() => navigate('/enrica/profilo/aggiungi')}>
                            <EuroIcon className='euroIcon'/>
                            <p>Aggiungi</p>
                            <ArrowForwardIosIcon className='arrow'/>
                        </div>
                    </div>
                ) : null
            }
        </>
    )
}

export default PaymentBox
